export default axios => ({
  create (payload) {
    return axios.post('/question', payload)
  },
  edit (questionnaireId, payload) {
    return axios.patch(`/question/${questionnaireId}`, payload)
  },
  delete (questionnaireId, payload) {
    return axios.delete(`/question/${questionnaireId}`, payload)
  },
  getCompendium (type) {
    return axios.get(`/compendium/${type}`)
  }
})
